<template>
  <!-- 新增功能 -->
  <div class="add_func">
    <!-- 顶部的进度 -->
    <div class="progress">
      <div class="progress_1">
        <v-icon class="icon"
                :style="{ background: $vuetify.theme.defaults.light.primary }"
                color="#fff">{{ progress === 1 ? 'mdi-pencil-outline' : 'mdi-check' }}</v-icon>
        <span>{{ $t('label_Function_details') }}</span>
      </div>
      <v-divider></v-divider>
      <div class="progress_1">
        <v-icon class="icon"
                color="#fff"
                :style="{
            background:
              progress === 2
                ? $vuetify.theme.defaults.light.primary
                : '#737273cc',
          }">
          {{ progress === 2 ? 'mdi-pencil-outline' : 2 }}
        </v-icon>
        <span>{{ $t('label_button') }}</span>
      </div>
    </div>
    <!-- 功能 -->
    <add-func v-show="progress === 1"
              @getData="getFuncData"
              @getBtnClientType="getBtnClientType"
              @getVersion_uuid="getVersion_uuid"></add-func>
    <!-- 按钮 -->
    <!-- :version="func_data.version" -->
    <addBtn ref="addFuncBtn"
            v-show="progress === 2"
            :client_type="btnClientType"
            :version_uuid="func_data.version_uuid"
            :module_uuid="func_data.module_uuid"
            @cancel="lastStep"
            @success="success"></addBtn>
  </div>
</template>

<script>
import { getBusinessList, get_func_add } from '@/service/api/func_module'
import addFunc from './func'
import addBtn from './btn'
export default {
  components: { addFunc, addBtn },
  props: {},
  data () {
    return {
      progress: 1,
      func_data: {
        client_type: '',
        version_uuid: '',
      },
      btnClientType: [],
      version_uuid: '',
    }
  },
  created () { },
  mounted () { },
  methods: {
    //   添加功能的下一步   获取功能添加的数据  进入下一步按钮
    getFuncData (obj) {
      this.progress = 2
      this.func_data = obj
    },
    // 获取版本应该选择的客户端类型
    getBtnClientType (client_type) {
      this.btnClientType = client_type
    },
    // 功能选择版本的uuid
    getVersion_uuid (uuid) {
      this.version_uuid = uuid
    },
    // 上一步
    lastStep () {
      this.progress = 1
    },
    // 提交
    async success (arr, files, deleteFiles) {
      // console.log('新增');
      let urllist = [] //上传图片url集合
      Promise.all(files.map((item) => { //上传图片
        return new Promise((resolve, reject) => {
          this.$uploadFiles(item.file, { 
          module_uuid:'module',
          function_uuid: this.$store.state.menuFunctionUuid })
            .then(res => {
              if (typeof res == 'object' && res != undefined && res.code == 200) {
                arr.forEach(item1 => {
                  if (item1.uuid == item.uuid) {
                    item1.button_icon = res.uuid
                  }
                })
                urllist = res.uuid
              }
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      })).then(async res => {
        const mrbase_sys_function_buttons = arr
        const func_data = this.$clone(this.func_data)
        // org_level_uuid: this.$store.state.userData.org_level_uuid
        const obj = Object.assign({}, func_data, { mrbase_sys_function_buttons })
        this.$refs.addFuncBtn.submitLoading = true
        const addDone = await get_func_add(obj)
        if (addDone.code == 200) {
          this.$Message({ text: this.$t('message_The_operation_was_successful') })
          this.$router.push({
            name: 'module_func_manage',
          })
        }
        else {
          if(urllist&&urllist.length)
            this.$deleteFile(urllist)
          this.$router.push({
            name: 'module_func_manage',
          })
        }
        this.$refs.addFuncBtn.submitLoading = false
      })
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped>
.progress {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.progress_1 {
  display: flex;
}
.progress_1 .icon {
  border-radius: 50%;
  /* background-color: #ffad4d; */
  font-size: 14px;
  width: 22px;
  height: 22px;
}
.progress_1 span {
  margin: 0 5px;
  font-size: 14px;
  font-weight: 600;
}
</style>
